<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import { settingService } from "../../../services";
import config from "../../../config";
import { success_message, error_message } from "../../../Helper/helper";

/**
 * Starter component
 */
export default {
  data() {
    return {
      config: config,
      setting: [],
      payment_gateway_list: [],
      setting: {
        payment_gateway: "paypal",
        merchant_id: "",
        access_code: "",
        working_key: "",
        payumoney_header: "",
        payumoney_salt: "",
        payumoney_key: "",
        key_id: "",
        key_secret: "",
        stripe_publishable_key: "",
        stripe_secret_key: "",
        publishable_key: "",
        secret_key: "",
        wompi_client_id: "",
        wompi_client_secret: "",
        paytab_merchant_email: "",
        paytab_client_secret: "",
        sslcommerz_store_id: "",
        sslcommerz_store_password: "",
        paytm_merchant_id: "",
        paytm_merchant_key: "",
        xente_api_key: "",
        xente_password: "",
        kina_terminal: "",
        kina_merchant_id: "",
        kina_merchant_name: "",
        kina_secret_key: "",
        paypal_client_key: "",
        paypal_secret_key: "",
      },

      cod_customer_type: "",
      cod_status: "",
      cod_order_type: "",
      cod_id: "",
      paypal_customer_type: "0",
      paypal_order_type: "0",
      paypal_status: "1",
      paypal_id: "",
      paypal_client_key: "",
      paypal_secret_key: "",
      klarna_customer_type: "0",
      klarna_status: "1",
      google_pay_customer_type: "0",
      google_pay_order_type: "0",
      google_pay_status: "1",
      google_pay_id: "",
      apple_pay_customer_type: "0",
      apple_pay_order_type: "0",
      apple_pay_status: "1",
      apple_pay_id: "",
      pay_on_account_customer_type: "0",
      pay_on_account_order_type: "0",
      pay_on_account_status: "1",
      pay_on_account_id: "",
    };
  },
  mounted() {
    this.getAppSetting();
    this.getPaymentGatewayList();
  },
  methods: {
    getAppSetting() {
      settingService.getAppSettingApi().then((response) => {
        this.setting = response.data.result.settings;
      });
    },
    getPaymentGatewayList() {
      let that = this;
      settingService.getPaymentGatewayList().then((response) => {
        this.payment_gateway_list = response.data.result;
        response.data.result.forEach(function (value) {
          if (value.gateway_name == "cod") {
            that.cod_id = value.id;
            that.cod_customer_type = value.customer_type;
            that.cod_status = value.status;
            that.cod_order_type = value.order_type;
          }
          if (value.gateway_name == "paypal") {
            that.paypal_id = value.id;
            that.paypal_customer_type = value.customer_type;
            that.paypal_status = value.status;
            that.paypal_order_type = value.order_type;
          }
          if (value.gateway_name == "googlePay") {
            that.google_pay_id = value.id;
            that.google_pay_customer_type = value.customer_type;
            that.google_pay_status = value.status;
            that.google_pay_order_type = value.order_type;
          }
          if (value.gateway_name == "applePay") {
            that.apple_pay_id = value.id;
            that.apple_pay_customer_type = value.customer_type;
            that.apple_pay_status = value.status;
            that.apple_pay_order_type = value.order_type;
          }
          if (value.gateway_name == "payOnAccount") {
            that.pay_on_account_id = value.id;
            that.pay_on_account_customer_type = value.customer_type;
            that.pay_on_account_status = value.status;
            that.pay_on_account_order_type = value.order_type;
          }
        });
      });
    },
    generalIt() {
      // this.$v.$touch();
      // if (this.$v.setting.$invalid) {
      //   return;
      // } else {
      const fd = new FormData();
      fd.append("cod_id", this.cod_id);
      fd.append("cod_customer_type", this.cod_customer_type);
      fd.append("cod_status", this.cod_status);
      fd.append("cod_order_type", this.cod_order_type);

      fd.append("google_pay_customer_type", this.google_pay_customer_type);
      fd.append("google_pay_order_type", this.google_pay_order_type);
      fd.append("google_pay_status", this.google_pay_status);
      fd.append("google_pay_id", this.google_pay_id);

      fd.append("apple_pay_customer_type", this.apple_pay_customer_type);
      fd.append("apple_pay_order_type", this.apple_pay_order_type);
      fd.append("apple_pay_status", this.apple_pay_status);
      fd.append("apple_pay_id", this.apple_pay_id);

      fd.append(
        "pay_on_account_customer_type",
        this.pay_on_account_customer_type
      );
      fd.append("pay_on_account_order_type", this.pay_on_account_order_type);
      fd.append("pay_on_account_status", this.pay_on_account_status);
      fd.append("pay_on_account_id", this.pay_on_account_id);

      fd.append("paypal_id", this.paypal_id);
      fd.append("paypal_order_type", this.paypal_order_type);
      fd.append("paypal_customer_type", this.paypal_customer_type);
      fd.append("paypal_status", this.paypal_status);
      fd.append("paypal_client_key", this.paypal_client_key);
      fd.append("paypal_secret_key", this.paypal_secret_key);

      // console.log("out", this.setting.payment_gateway);
      // if (this.setting.payment_gateway == "paypal") {
      //   console.log("in", this.setting.payment_gateway);
      //   fd.append("paypal_client_key", this.setting.paypal_client_key);
      //   fd.append("paypal_secret_key", this.setting.paypal_secret_key);
      //   fd.append("paypal_customer_type", this.paypal_customer_type);
      //   fd.append("paypal_status", this.paypal_status);
      //   fd.append("type", 1);
      // } else if (this.setting.payment_gateway == "stripe") {
      //   fd.append(
      //     "stripe_publishable_key",
      //     this.setting.stripe_publishable_key
      //   );
      //   fd.append("stripe_secret_key", this.setting.stripe_secret_key);
      //   fd.append("type", 2);
      // }
      console.log(fd);
      settingService.updatepaymentgateway(fd).then((response) => {
        this.getAppSetting();
        this.getPaymentGatewayList();
        if (response.data.code === 200) {
          success_message(response.data.message);
        } else {
          error_message(response.data.message);
        }
      });
      // }
    },
  },
};
</script>
<template>
  <b-form @submit.prevent="generalIt">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label">{{
                    trans.get("__JSON__.Payment Method")
                  }}</label>
                </div>
              </div>
            </div>

            <div v-for="gateway in payment_gateway_list" :key="gateway.id" style="margin-top: 25px">
              <div v-if="gateway.gateway_name == 'cod'">
                <div class="row">
                  <div class="col-sm-12">
                    <h5 style="text-transform: capitalize">
                      {{ gateway.gateway_name }} :-
                    </h5>
                  </div>
                </div>
                <div class="row">
                  <!-- <div class="col-sm-4">
                    <b-form-group
                      id="input-group-1"
                      :label="trans.get('__JSON__.Client ID')"
                      label-for="name"
                    >
                     <b-form-input
                        id="paypal_client_key"
                        name="paypal_client_key"
                        v-model="setting.paypal_client_key"
                        type="text"
                        :placeholder="trans.get('__JSON__.Client ID')"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-sm-4">
                    <b-form-group
                      id="input-group-1"
                      :label="trans.get('__JSON__.Client Secret')"
                      label-for="name"
                    >
                     <b-form-input
                        id="paypal_secret_key"
                        name="paypal_secret_key"
                        v-model="setting.paypal_secret_key"
                        type="text"
                        :placeholder="trans.get('__JSON__.Client Secret')"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div> -->

                  <!-- <div class="col-sm-2">
                    <b-form-group
                      id="input-group-1"
                      :label="trans.get('__JSON__.Customer Type')"
                      label-for="name"
                    >
                      <select
                        name="user_role"
                        class="custom-select"
                        id="user_role"
                        v-model="cod_customer_type"
                      >
                        <option value="">
                          {{ trans.get("__JSON__.Select Customer Type") }}
                        </option>
                        <option value="0">Both</option>
                        <option value="1">Business</option>
                        <option value="2">Private</option>
                      </select>
                    </b-form-group>
                  </div> -->

                  <!-- <div class="col-sm-2">
                    <b-form-group
                      id="input-group-1"
                      :label="trans.get('__JSON__.Order Type')"
                      label-for="name"
                    >
                      <select
                        name="user_role"
                        class="custom-select"
                        id="user_role"
                        v-model="cod_order_type"
                      >
                        <option value="">
                          {{ trans.get("__JSON__.Select Order Type") }}
                        </option>
                        <option value="0" :selected="gateway.order_type == '0'">
                          Both
                        </option>
                        <option value="1" :selected="gateway.order_type == '1'">
                          Normal
                        </option>
                        <option value="2" :selected="gateway.order_type == '2'">
                          Subscription
                        </option>
                      </select>
                    </b-form-group>
                  </div> -->

                  <div class="col-md-2 vendor-status">
                    <b-form-group
                      id="input-group-2"
                      :label="trans.get('__JSON__.Status')"
                      label-for="Parking Place"
                    >
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="swtich-data">
                            <label class="switch">
                              <input
                                type="checkbox"
                                id="togBtn"
                                class="switch-on"
                                name="status"
                                v-model="cod_status"
                                true-value="1"
                                false-value="0"
                              />
                              <div class="slider round">
                                <span class="on">{{
                                  trans.get("__JSON__.Active")
                                }}</span>
                                <span class="off">{{
                                  trans.get("__JSON__.Inactive")
                                }}</span>
                              </div>
                            </label>
                          </div>
                        </div>
                      </div>
                    </b-form-group>
                  </div>
                </div>
              </div>

              <div v-if="gateway.gateway_name == 'googlePay'">
                <div class="row">
                  <div class="col-sm-12">
                    <h5 style="text-transform: capitalize">
                      {{ gateway.gateway_name }} :-
                    </h5>
                  </div>
                </div>
                <div class="row">
                  <!-- <div class="col-sm-2">
                    <b-form-group
                      id="input-group-1"
                      :label="trans.get('__JSON__.Customer Type')"
                      label-for="name"
                    >
                      <select
                        name="user_role"
                        class="custom-select"
                        id="user_role"
                        v-model="google_pay_customer_type"
                      >
                        <option value="">
                          {{ trans.get("__JSON__.Select Customer Type") }}
                        </option>
                        <option value="0" selected>Both</option>
                        <option value="1" selected>Business</option>
                        <option value="2">Private</option>
                      </select>
                    </b-form-group>
                  </div> -->

                  <!-- <div class="col-sm-2">
                    <b-form-group
                      id="input-group-1"
                      :label="trans.get('__JSON__.Order Type')"
                      label-for="name"
                    >
                      <select
                        name="user_role"
                        class="custom-select"
                        id="user_role"
                        v-model="google_pay_order_type"
                      >
                        <option value="">
                          {{ trans.get("__JSON__.Select Order Type") }}
                        </option>
                        <option value="0" selected>Both</option>
                        <option value="1" selected>Normal</option>
                        <option value="2">Subscription</option>
                      </select>
                    </b-form-group>
                  </div> -->

                  <div class="col-md-2 vendor-status">
                    <b-form-group
                      id="input-group-2"
                      :label="trans.get('__JSON__.Status')"
                      label-for="Parking Place"
                    >
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="swtich-data">
                            <label class="switch">
                              <input
                                type="checkbox"
                                id="togBtn"
                                class="switch-on"
                                name="status"
                                v-model="google_pay_status"
                                true-value="1"
                                false-value="0"
                              />
                              <div class="slider round">
                                <span class="on">{{
                                  trans.get("__JSON__.Active")
                                }}</span>
                                <span class="off">{{
                                  trans.get("__JSON__.Inactive")
                                }}</span>
                              </div>
                            </label>
                          </div>
                        </div>
                      </div>
                    </b-form-group>
                  </div>
                </div>
              </div>

              <div v-if="gateway.gateway_name == 'applePay'">
                <div class="row">
                  <div class="col-sm-12">
                    <h5 style="text-transform: capitalize">
                      {{ gateway.gateway_name }} :-
                    </h5>
                  </div>
                </div>
                <div class="row">
                  <!-- <div class="col-sm-2">
                    <b-form-group
                      id="input-group-1"
                      :label="trans.get('__JSON__.Customer Type')"
                      label-for="name"
                    >
                      <select
                        name="user_role"
                        class="custom-select"
                        id="user_role"
                        v-model="apple_pay_customer_type"
                      >
                        <option value="">
                          {{ trans.get("__JSON__.Select Customer Type") }}
                        </option>
                        <option value="0" selected>Both</option>
                        <option value="1" selected>Business</option>
                        <option value="2">Private</option>
                      </select>
                    </b-form-group>
                  </div> -->

                  <!-- <div class="col-sm-2">
                    <b-form-group
                      id="input-group-1"
                      :label="trans.get('__JSON__.Order Type')"
                      label-for="name"
                    >
                      <select
                        name="user_role"
                        class="custom-select"
                        id="user_role"
                        v-model="apple_pay_order_type"
                      >
                        <option value="">
                          {{ trans.get("__JSON__.Select Order Type") }}
                        </option>
                        <option value="0" selected>Both</option>
                        <option value="1" selected>Normal</option>
                        <option value="2">Subscription</option>
                      </select>
                    </b-form-group>
                  </div> -->

                  <div class="col-md-2 vendor-status">
                    <b-form-group
                      id="input-group-2"
                      :label="trans.get('__JSON__.Status')"
                      label-for="Parking Place"
                    >
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="swtich-data">
                            <label class="switch">
                              <input
                                type="checkbox"
                                id="togBtn"
                                class="switch-on"
                                name="status"
                                v-model="apple_pay_status"
                                true-value="1"
                                false-value="0"
                              />
                              <div class="slider round">
                                <span class="on">{{
                                  trans.get("__JSON__.Active")
                                }}</span>
                                <span class="off">{{
                                  trans.get("__JSON__.Inactive")
                                }}</span>
                              </div>
                            </label>
                          </div>
                        </div>
                      </div>
                    </b-form-group>
                  </div>
                </div>
              </div>

              <div v-if="gateway.gateway_name == 'payOnAccount'">
                <div class="row">
                  <div class="col-sm-12">
                    <h5 style="text-transform: capitalize">
                      {{ gateway.gateway_name }} :-
                    </h5>
                  </div>
                </div>
                <div class="row">
                  <!-- <div class="col-sm-2">
                    <b-form-group
                      id="input-group-1"
                      :label="trans.get('__JSON__.Customer Type')"
                      label-for="name"
                    >
                      <select
                        name="user_role"
                        class="custom-select"
                        id="user_role"
                        v-model="pay_on_account_customer_type"
                      >
                        <option value="">
                          {{ trans.get("__JSON__.Select Customer Type") }}
                        </option>
                        <option value="0" selected>Both</option>
                        <option value="1" selected>Business</option>
                        <option value="2">Private</option>
                      </select>
                    </b-form-group>
                  </div> -->

                  <!-- <div class="col-sm-2">
                    <b-form-group
                      id="input-group-1"
                      :label="trans.get('__JSON__.Order Type')"
                      label-for="name"
                    >
                      <select
                        name="user_role"
                        class="custom-select"
                        id="user_role"
                        v-model="pay_on_account_order_type"
                      >
                        <option value="">
                          {{ trans.get("__JSON__.Select Order Type") }}
                        </option>
                        <option value="0" selected>Both</option>
                        <option value="1" selected>Normal</option>
                        <option value="2">Subscription</option>
                      </select>
                    </b-form-group>
                  </div> -->

                  <div class="col-md-2 vendor-status">
                    <b-form-group
                      id="input-group-2"
                      :label="trans.get('__JSON__.Status')"
                      label-for="Parking Place"
                    >
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="swtich-data">
                            <label class="switch">
                              <input
                                type="checkbox"
                                id="togBtn"
                                class="switch-on"
                                name="status"
                                v-model="pay_on_account_status"
                                true-value="1"
                                false-value="0"
                              />
                              <div class="slider round">
                                <span class="on">{{
                                  trans.get("__JSON__.Active")
                                }}</span>
                                <span class="off">{{
                                  trans.get("__JSON__.Inactive")
                                }}</span>
                              </div>
                            </label>
                          </div>
                        </div>
                      </div>
                    </b-form-group>
                  </div>
                </div>
              </div>

              <div v-if="gateway.gateway_name == 'paypal'">
                <div class="row">
                  <div class="col-sm-12">
                    <h5 style="text-transform: capitalize">
                      {{ gateway.gateway_name }} :-
                    </h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <b-form-group
                      id="input-group-1"
                      :label="trans.get('__JSON__.Client ID')"
                      label-for="name"
                    >
                      <b-form-input
                        id="paypal_client_key"
                        name="paypal_client_key"
                        v-model="paypal_client_key"
                        type="text"
                        :placeholder="trans.get('__JSON__.Client ID')"
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-sm-4">
                    <b-form-group
                      id="input-group-1"
                      :label="trans.get('__JSON__.Client Secret')"
                      label-for="name"
                    >
                      <b-form-input
                        id="paypal_secret_key"
                        name="paypal_secret_key"
                        v-model="paypal_secret_key"
                        type="text"
                        :placeholder="trans.get('__JSON__.Client Secret')"
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <!-- <div class="col-sm-2">
                    <b-form-group
                      id="input-group-1"
                      :label="trans.get('__JSON__.Customer Type')"
                      label-for="name"
                    >
                      <select
                        name="user_role"
                        class="custom-select"
                        id="user_role"
                        v-model="paypal_customer_type"
                      >
                        <option value="">
                          {{ trans.get("__JSON__.Select Customer Type") }}
                        </option>
                        <option value="0" selected>Both</option>
                        <option value="1" selected>Private</option>
                        <option value="2">Business</option>
                      </select>
                    </b-form-group>
                  </div> -->

                  <!-- <div class="col-sm-2">
                    <b-form-group
                      id="input-group-1"
                      :label="trans.get('__JSON__.Order Type')"
                      label-for="name"
                    >
                      <select
                        name="user_role"
                        class="custom-select"
                        id="user_role"
                        v-model="paypal_order_type"
                      >
                        <option value="">
                          {{ trans.get("__JSON__.Select Order Type") }}
                        </option>
                        <option value="0" selected>Both</option>
                        <option value="1" selected>Normal</option>
                        <option value="2">Subscription</option>
                      </select>
                    </b-form-group>
                  </div> -->

                  <div class="col-md-2 vendor-status">
                    <b-form-group
                      id="input-group-2"
                      :label="trans.get('__JSON__.Status')"
                      label-for="Parking Place"
                    >
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="swtich-data">
                            <label class="switch">
                              <input
                                type="checkbox"
                                id="togBtn"
                                class="switch-on"
                                name="status"
                                v-model="paypal_status"
                                true-value="1"
                                false-value="0"
                              />
                              <div class="slider round">
                                <span class="on">{{
                                  trans.get("__JSON__.Active")
                                }}</span>
                                <span class="off">{{
                                  trans.get("__JSON__.Inactive")
                                }}</span>
                              </div>
                            </label>
                          </div>
                        </div>
                      </div>
                    </b-form-group>
                  </div>
                </div>
              </div>

              <!-- <div v-if="gateway.gateway_name == 'klarna'">
                <div class="row">
                  <div class="col-sm-12">
                    <h5 style="text-transform: capitalize;">{{gateway.gateway_name}} :-</h5>
                  </div>
                </div>
                <div class="row">
                  
                  <div class="col-sm-4">
                    <b-form-group
                      id="input-group-1"
                      :label="trans.get('__JSON__.Client ID')"
                      label-for="name"
                    >
                     <b-form-input
                        id="paypal_client_key"
                        name="paypal_client_key"
                        v-model="setting.paypal_client_key"
                        type="text"
                        :placeholder="trans.get('__JSON__.Client ID')"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-sm-4">
                    <b-form-group
                      id="input-group-1"
                      :label="trans.get('__JSON__.Client Secret')"
                      label-for="name"
                    >
                     <b-form-input
                        id="paypal_secret_key"
                        name="paypal_secret_key"
                        v-model="setting.paypal_secret_key"
                        type="text"
                        :placeholder="trans.get('__JSON__.Client Secret')"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-sm-2">
                    <b-form-group
                      id="input-group-1"
                      :label="trans.get('__JSON__.Customer Type')"
                      label-for="name"
                    >
                      <select
                        name="user_role"
                        class="custom-select"
                        id="user_role"
                        v-model="klarna_customer_type"
                      >
                        <option value="">{{ trans.get('__JSON__.Select Customer Type') }}</option>
                        <option value="0" selected>Both</option>
                        <option value="1" selected>Private</option>
                        <option value="2">Business</option>
                      </select>
                    </b-form-group>
                  </div>

                  <div class="col-md-2 vendor-status">
                    <b-form-group id="input-group-2" :label="trans.get('__JSON__.Status')" label-for="Parking Place" >
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="swtich-data">
                                    <label class="switch">
                                    <input
                                        type="checkbox"
                                        id="togBtn"
                                        class="switch-on"
                                        name="status"
                                        v-model="klarna_status"
                                        true-value="1"
                                        false-value="0"
                                    />
                                    <div class="slider round">
                                        <span class="on">{{ trans.get('__JSON__.Active') }}</span>
                                        <span class="off">{{ trans.get('__JSON__.Inactive') }}</span>
                                    </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </b-form-group>
                  </div>
                  
                </div>
              </div> -->
            </div>
            <div class="btn-update">
              <div class="col-sm-6">
                <button
                  type="submit"
                  v-if="
                    $auth.hasPermission(config.permissions.configuration_write)
                  "
                  class="btn btn-primary mr-1 mt-3"
                >
                  {{ trans.get("__JSON__.Update") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-form>
</template>